import React, { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PricingTableModal from '../PricingTableModal/PricingTableModal';

export default function AuthenticatedPricingModal({
	create_checkout_session_endpoint,
	stripe_public_key,
	stripe_product_essential_id,
	stripe_product_advanced_id,
	stripe_product_ultimate_id
}) {
	const { showPricingModal, closePricingModal } = useAuth();
	const modalRef = useRef(null);

	useEffect(() => {
		if (!showPricingModal) return undefined;

		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				closePricingModal();
			}
		};

		document.body.style.overflow = 'hidden';
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.body.style.overflow = '';
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showPricingModal, closePricingModal]);

	return (
		<PricingTableModal
			ref={modalRef}
			isOpen={showPricingModal}
			onClose={closePricingModal}
			create_checkout_session_endpoint={create_checkout_session_endpoint}
			stripe_public_key={stripe_public_key}
			stripe_product_essential_id={stripe_product_essential_id}
			stripe_product_advanced_id={stripe_product_advanced_id}
			stripe_product_ultimate_id={stripe_product_ultimate_id}
		/>
	);
}
